import { StaticImage } from "gatsby-plugin-image";
import gatsbyCreateGitRepoImg from "../../../../src/images/gatsby/gatsby_create_git_repo.png";
import gatsbyGitRepoImg from "../../../../src/images/gatsby/gatsby_git_repo.png";
import gatsbyDefaultStarter from "../../../../src/images/gatsby/gatsby_default_starter.png";
import gatsbyDeploySuccess from "../../../../src/images/gatsby/gatsby_deploy_success.png";
import * as React from 'react';
export default {
  StaticImage,
  gatsbyCreateGitRepoImg,
  gatsbyGitRepoImg,
  gatsbyDefaultStarter,
  gatsbyDeploySuccess,
  React
};